(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cartRoot = document.querySelector('[data-yx-cart]');
    if (!cartRoot) return;

    /* Product-card Quick Buy already confirms the Cart API mutation and emits
       `cart:update`. The Cart page is server-rendered, so refresh it after a
       successful add. Desktop keeps its immediate refresh; mobile and tablet
       keep the short "Added to your cart" confirmation before the same reload,
       without requiring a close, backdrop, or View Cart click. */
    document.addEventListener('cart:update', (event) => {
      if (event.detail?.data?.source !== 'product-card-quick-buy') return;
      const delay = window.matchMedia('(min-width: 1200px)').matches ? 0 : 650;
      window.setTimeout(() => window.location.reload(), delay);
    });

    let cartUpdatePending = false;
    const updateError = cartRoot.querySelector('[data-yx-cart-update-error]');
    const updateCart = async (url, payload) => {
      if (cartUpdatePending) return;
      cartUpdatePending = true;
      const controls = [...cartRoot.querySelectorAll('button, input')];
      const previousDisabled = controls.map((control) => control.disabled);
      controls.forEach((control) => { control.disabled = true; });
      cartRoot.setAttribute('aria-busy', 'true');
      if (updateError) updateError.hidden = true;
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      } catch (error) {
        controls.forEach((control, index) => { control.disabled = previousDisabled[index]; });
        cartRoot.querySelectorAll('[data-yx-cart-qty-input]').forEach((input) => {
          input.value = input.closest('[data-yx-cart-item]').dataset.quantity;
        });
        cartUpdatePending = false;
        cartRoot.removeAttribute('aria-busy');
        if (updateError) {
          updateError.textContent = document.documentElement.lang === 'es'
            ? 'No se pudo actualizar el carrito. Inténtalo de nuevo.'
            : 'The cart could not be updated. Please try again.';
          updateError.hidden = false;
        }
      }
    };
    const changeLine = (key, quantity) => updateCart('/cart/change.js', { id: key, quantity });

    cartRoot.addEventListener('submit', (event) => {
      if (cartUpdatePending) event.preventDefault();
    });

    const removeSelected = cartRoot.querySelector('[data-yx-cart-remove-selected]');
    const selectAll = cartRoot.querySelector('[data-yx-cart-select-all]');
    const promoInput = cartRoot.querySelector('[data-yx-cart-promo]');
    const promoStatus = cartRoot.querySelector('[data-yx-cart-promo-status]');
    const removePromo = cartRoot.querySelector('[data-yx-cart-promo-remove]');

    const setPromoError = (message = '') => {
      if (promoStatus) {
        promoStatus.removeAttribute('data-pending');
        promoStatus.textContent = message;
        promoStatus.hidden = !message;
      }
      if (promoInput) promoInput.setAttribute('aria-invalid', String(Boolean(message)));
    };

    const invalidPromoMessage = document.documentElement.lang === 'es'
      ? 'Este código promocional no es válido o no está disponible.'
      : 'This promo code is invalid or unavailable.';
    try {
      if (sessionStorage.getItem('yx-cart-promo-error') === 'invalid') {
        sessionStorage.removeItem('yx-cart-promo-error');
        setPromoError(invalidPromoMessage);
      }
    } catch {}

    if (promoInput) {
      // Shipping codes can be active without a merchandise discount allocation.
      // Reconcile with Shopify, but never overwrite something the buyer is typing.
      let promoEdited = false;
      promoInput.addEventListener('input', () => { promoEdited = true; });
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
        .then((state) => {
          const codes = (state.discount_codes || []).filter((entry) => entry.applicable).map((entry) => entry.code);
          if (!promoEdited) promoInput.value = codes.join(', ');
          if (removePromo) removePromo.hidden = codes.length === 0;
        })
        .catch(() => { /* Keep the server-rendered applied code when offline. */ });
      let pasteTimer;
      removePromo?.addEventListener('click', () => {
        clearTimeout(pasteTimer);
        updateCart('/cart/update.js', { discount: '' });
      });
      const applyPromoCode = async () => {
        clearTimeout(pasteTimer);
        if (cartUpdatePending) return;
        const discount = promoInput.value.trim();
        if (!discount) {
          if (removePromo && !removePromo.hidden) updateCart('/cart/update.js', { discount: '' });
          return;
        }
        setPromoError();
        cartUpdatePending = true;
        cartRoot.setAttribute('aria-busy', 'true');
        const controls = [...cartRoot.querySelectorAll('button, input')];
        const previousDisabled = controls.map((control) => control.disabled);
        controls.forEach((control) => { control.disabled = true; });
        if (promoStatus) {
          promoStatus.textContent = document.documentElement.lang === 'es' ? 'Aplicando código…' : 'Applying code…';
          promoStatus.setAttribute('data-pending', '');
          promoStatus.hidden = false;
        }
        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            signal: AbortSignal.timeout(15000),
            body: JSON.stringify({ discount }),
          });
          if (!response.ok) throw new Error('Unable to apply promo code.');
          const cartState = await response.json();
          const requested = discount.split(',').map((code) => code.trim().toLowerCase()).filter(Boolean);
          const applied = requested.every((code) => (cartState.discount_codes || []).some((entry) => (
            entry?.applicable === true && entry.code?.trim().toLowerCase() === code
          )));
          if (!applied) {
            // Invalid replacements can remove an old code: refresh all cart totals too.
            try { sessionStorage.setItem('yx-cart-promo-error', 'invalid'); } catch {}
          }
          window.location.reload();
        } catch (error) {
          console.error(error);
          setPromoError(document.documentElement.lang === 'es'
            ? 'No se pudo comprobar el código promocional. Inténtalo de nuevo.'
            : 'The promo code could not be checked. Please try again.');
          controls.forEach((control, index) => { control.disabled = previousDisabled[index]; });
          cartUpdatePending = false;
          cartRoot.removeAttribute('aria-busy');
          promoInput.focus();
        }
      };
      promoInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.isComposing) return;
        event.preventDefault();
        applyPromoCode();
      });
      promoInput.addEventListener('change', () => {
        clearTimeout(pasteTimer);
        pasteTimer = setTimeout(applyPromoCode, 300);
      });
      promoInput.addEventListener('paste', () => {
        clearTimeout(pasteTimer);
        pasteTimer = setTimeout(applyPromoCode, 300);
      });
    }
    const checkoutButton = cartRoot.querySelector('.yx-cart__checkout');
    const stickyCheckout = cartRoot.querySelector('[data-yx-cart-mobile-checkout]');

    if (checkoutButton && stickyCheckout) {
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      let frame;
      const syncStickyCheckout = () => {
        frame = undefined;
        const checkoutHasScrolledPast = mobileQuery.matches && checkoutButton.getBoundingClientRect().bottom < 0;
        stickyCheckout.hidden = !checkoutHasScrolledPast;
        stickyCheckout.setAttribute('aria-hidden', String(!checkoutHasScrolledPast));
      };
      const requestStickyCheckoutSync = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(syncStickyCheckout);
      };

      syncStickyCheckout();
      window.addEventListener('scroll', requestStickyCheckoutSync, { passive: true });
      window.addEventListener('resize', requestStickyCheckoutSync, { passive: true });
      mobileQuery.addEventListener('change', requestStickyCheckoutSync);
    }

    const syncSelection = () => {
      const lines = [...cartRoot.querySelectorAll('[data-yx-cart-line-select]')];
      const checked = lines.filter((input) => input.checked);
      if (removeSelected) removeSelected.hidden = checked.length === 0;
      if (selectAll) {
        selectAll.checked = lines.length > 0 && checked.length === lines.length;
        selectAll.indeterminate = checked.length > 0 && checked.length < lines.length;
      }
    };

    const lineSelections = [...cartRoot.querySelectorAll('[data-yx-cart-line-select]')];
    if (window.matchMedia('(max-width: 749px)').matches && lineSelections.length) {
      lineSelections.forEach((input) => { input.checked = true; });
    }
    syncSelection();

    cartRoot.addEventListener('click', (event) => {
      if (cartUpdatePending) return;
      const qtyButton = event.target.closest('[data-yx-cart-qty]');
      const removeButton = event.target.closest('[data-yx-cart-remove-line]');
      const removeSelectedButton = event.target.closest('[data-yx-cart-remove-selected]');

      if (qtyButton) {
        const item = qtyButton.closest('[data-yx-cart-item]');
        const input = item && item.querySelector('[data-yx-cart-qty-input]');
        const key = item && item.dataset.lineKey;
        if (!item || !input || !key) return;
        const parsed = Number.parseInt(input.value || item.dataset.quantity || '1', 10);
        const current = Number.isFinite(parsed) && parsed >= 0 ? parsed : Number.parseInt(item.dataset.quantity || '1', 10);
        const next = qtyButton.dataset.yxCartQty === 'increase' ? current + 1 : Math.max(0, current - 1);
        event.preventDefault();
        changeLine(key, next);
      }

      if (removeButton) {
        const item = removeButton.closest('[data-yx-cart-item]');
        const key = item && item.dataset.lineKey;
        if (!key) return;
        event.preventDefault();
        changeLine(key, 0);
      }

      if (removeSelectedButton) {
        const selected = [...cartRoot.querySelectorAll('[data-yx-cart-line-select]:checked')].map((input) => input.value);
        event.preventDefault();
        if (!selected.length) return;
        const updates = Object.fromEntries(selected.map((key) => [key, 0]));
        updateCart('/cart/update.js', { updates });
      }
    });

    cartRoot.addEventListener('change', (event) => {
      if (cartUpdatePending) return;
      const selectAllInput = event.target.closest('[data-yx-cart-select-all]');
      const lineSelect = event.target.closest('[data-yx-cart-line-select]');
      const qtyInput = event.target.closest('[data-yx-cart-qty-input]');

      if (selectAllInput) {
        cartRoot.querySelectorAll('[data-yx-cart-line-select]').forEach((input) => {
          input.checked = selectAllInput.checked;
        });
        syncSelection();
      }

      if (lineSelect) {
        syncSelection();
      }

      if (qtyInput) {
        const item = qtyInput.closest('[data-yx-cart-item]');
        const key = item && item.dataset.lineKey;
        if (!key) return;
        const parsed = Number.parseInt(qtyInput.value, 10);
        if (!Number.isFinite(parsed) || parsed < 0) {
          qtyInput.value = item.dataset.quantity || qtyInput.defaultValue || '1';
          return;
        }
        changeLine(key, parsed);
      }
    });
  })();


  } catch(e) { console.error(e); }
})();
})();
